var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBigIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF3B30",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 20.75H18.25",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 28.25V38.25",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 28.25V38.25",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 20.75V44.5C43.25 44.8315 43.1183 45.1495 42.8839 45.3839C42.6495 45.6183 42.3315 45.75 42 45.75H22C21.6685 45.75 21.3505 45.6183 21.1161 45.3839C20.8817 45.1495 20.75 44.8315 20.75 44.5V20.75",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 20.75V18.25C38.25 17.587 37.9866 16.9511 37.5178 16.4822C37.0489 16.0134 36.413 15.75 35.75 15.75H28.25C27.587 15.75 26.9511 16.0134 26.4822 16.4822C26.0134 16.9511 25.75 17.587 25.75 18.25V20.75",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBigIcon);
export default __webpack_public_path__ + "static/media/deleteBigIcon.de71938dd99023e4e5003a1d199885d3.svg";
export { ForwardRef as ReactComponent };